export default __webpack_public_path__ + "static/media/deletedark.44a72eda.svg";